import axios from '@/axios'

export async function getRouteInfo(orderId) {
  const response = await axios.get(`order/${orderId}/route/info`)
  return response.data
}

export function xxx() {}
